<template>
  <div class="mc-liveview--fo-sidebar-accordion-item">
    <div header-tag="header" role="tab">
      <div v-b-toggle.accordion-3 class="d-flex justify-content-between">
        <h5>Daftar Pengiriman</h5>
        <div>
          <i class="mc-fa icon-fill_arrow-ios-down"></i>
          <i class="mc-fa icon-fill_arrow-ios-up"></i>
        </div>
      </div>
    </div>
    <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
      <div class="mc-liveview--fo-sidebar-delivery">
        <div
          v-for="(item, index) in dataDelivery"
          :key="index"
          class="mc-liveview--fo-sidebar-delivery-item"
        >
          <div :style="{ width: isLoading ? '20%' : '' }">
            <b-skeleton-wrapper :loading="isLoading">
              <template #loading>
                <b-skeleton width="80%" />
                <b-skeleton />
              </template>
              <p>{{ item.number }}</p>
              <span class="text-muted">
                <i class="mc-fa icon-outline_customer"></i> {{ item.customer.name }}
              </span>
            </b-skeleton-wrapper>
          </div>
          <div :style="{ width: isLoading ? '20%' : '' }">
            <b-skeleton-wrapper :loading="isLoading">
              <template #loading>
                <b-skeleton />
              </template>
              <McBadge
                :text="item.status.name"
                :variant="getBadgeVariant(item.status.raw_type)"
                size="medium"
                type="button"
              />
            </b-skeleton-wrapper>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import McBadge from '@/components/McBadge'

export default {
  components: { McBadge },
  props: {
    dataDelivery: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isLoading() {
      return this.loading
    },
  },
  methods: {
    getBadgeVariant(status) {
      switch (status) {
        case 'STARTED':
          return 'info'
        case 'PICKED':
          return 'warning'
        case 'DELIVERED':
          return 'success'
        case 'CANCELED':
          return 'canceled'
        case 'RESCHEDULED':
          return 'rescheduled'
      }
    },
  },
}
</script>
